module.exports = __webpack_public_path__ + "img/logo-acconomy-white.0895984d.svg";